import i18n from '@/plugins/i18n'

export const localeHelper = {
  getMessage,
  getCurrentLanguage,
  setCurrentLanguage
}

function getCurrentLanguage() {
  return i18n.locale
}

function setCurrentLanguage(language) {
  i18n.locale = language
}

function getMessage(key, dynamicValue = null) {
  return dynamicValue == null ? i18n.t(key) : i18n.t(key, dynamicValue)
}
